export default __webpack_public_path__ + "static/media/right_bush.ff5006d4.svg";